// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"edf42312","255":"c0f61eb6","551":"c5644aea","672":"0fe21c54","842":"36d9b53b"}[chunkId] + ".chunk.js";
};